import { gsap } from "gsap";

const handleCardToggle = (id) => {
  const card = document.getElementById("info-card-" + id);

  const timeline = gsap.timeline();
  timeline.fromTo(
    Array.from(card.querySelector(".info-children-wrapper").children),
    { opacity: 0, yPercent: 30 },
    { opacity: 1, yPercent: 0, duration: 0.5, stagger: 0.3 },
  );
};

export default {
  init: () => {
    document.addEventListener("info-card-toggle", (event) => {
      if (event.detail?.id) {
        handleCardToggle(event.detail?.id);
      }
    });
  },
};
